<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-4">
          Arvete e-mail:
        </div>
        <div class="col-8">
          <template v-for="(email, i) in request.invoiceEmails">

            <validated-form-input :name="'invoiceEmail' + i" placeholder="Arvete e-mail"
                                  v-model="request.invoiceEmails[i]"
                                  validate="required|email" :validator="$validator">

              <button type="button" class="btn btn-link btn-sm float-right" v-if="request.invoiceEmails.length > 1">
                <i class="mdi mdi-delete" @click="removeEmail(i)"></i>
              </button>

            </validated-form-input>

          </template>

          <button type="button" class="btn btn-link ml-0 pl-0 pt-0" @click="addEmail">
            <i class="mdi mdi-plus"></i> Lisa e-mail
          </button>

        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-form-checkbox v-model="request.detailedInvoice" :value="true" :unchecked-value="false">Eristused arvel</b-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import gateway from '@/services/gateway'

  export default {
    components: {ValidatedFormInput},
    props: ['client'],
    data() {
      return {
        request: {
          invoiceEmails: [].concat(this.client.invoiceEmails),
          detailedInvoice: this.client.detailedInvoice
        },
      }
    },
    methods: {
      addEmail() {
        this.request.invoiceEmails.push('')
      },
      removeEmail(index) {
        this.request.invoiceEmails.splice(index, 1)
      },
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post('/clients/' + this.client.id + '/invoice-settings', this.request)
            .then(() => this.$notifications.info('Arvete parameetrid muudetud'))
            .then(() => this.$emit('done'))
        })
      },
    }
  }
</script>
